module.exports = __webpack_public_path__ + "static/media/scoiattolo.0089c209.jpg";